<template>
    <div class="small">
        <bar-chart :options="{maintainAspectRatio: false}"
                   :styles="{height: '400px',width: '100%',position: 'relative'}"
                   :chart-data="data"></bar-chart>
    </div>
</template>

<script>
  import BarChart from './bar-chart';
  import moment from 'moment';

  export default {
    props: {
      collection: Array
    },

    components: {
      BarChart
    },

    data() {
      return {
        data: {}
      }
    },

    computed: {
      labels() {
        return this.collection.map((item) => {
          return moment().year(item.year).month(item.month).format('MMM-YYYY');
        })
      }
    },

    methods: {
      fillData() {
        this.data = {
          labels: this.labels,
          datasets: [
            {
              label: 'Visit Trends',
              borderColor: '#9edbff',
              pointBackgroundColor: '#303a42',
              borderWidth: 1,
              backgroundColor: '#9edbff',
              pointBorderColor: '#303a42',
              data: this.collection.map((item) => item.total)
            }
          ]
        }
      }
    },

    watch: {
      'collection': function () {
        this.fillData()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Charts/BarChart.vue